import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-y-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg leading-7 font-medium text-black" }, "When following property value/s change:", -1)
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "ml-3 text-sm leading-5 font-normal text-gray-900" }

import { onMounted, watch } from "vue"
import { useAttributesStore } from "@/stores/attributes"
import { useWorkflowStore } from "@/stores/workflow"
import GgmsCheckBox from "@/components/GgmsCheckBox.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'PropertyValueChangeTriggerSidebar',
  setup(__props) {

const workflowStore = useWorkflowStore()
const attributeStore = useAttributesStore()

function isValueChecked(value: string) {
    return !!workflowStore.selectedData.find((el) => el.name === value)
}

function onSelect(value: string, displayName: string) {
    if (isValueChecked(value)) {
        const index = workflowStore.selectedData.findIndex((el) => el.name === value)
        workflowStore.selectedData.splice(index, 1)
        return
    }
    workflowStore.selectedData.push({ name: value, label: displayName })
}

onMounted(async () => {
    await attributeStore.getAttributes("lead")
})

watch(
    () => workflowStore.selectedData,
    () => {
        workflowStore.areButtonDisabled = !workflowStore.selectedData.length
    },
    { deep: true }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(attributeStore).getAttributesForPropValueChange, (option) => {
      return (_openBlock(), _createElementBlock("div", {
        key: option._id,
        class: "flex flex-col",
        tabindex: "0",
        onClick: ($event: any) => (onSelect(option.name, option.displayName))
      }, [
        _createVNode(GgmsCheckBox, {
          checked: isValueChecked(option.name),
          classes: ['mt-1'],
          centered: false
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, _toDisplayString(option.displayName), 1)
          ]),
          _: 2
        }, 1032, ["checked"])
      ], 8, _hoisted_3))
    }), 128))
  ]))
}
}

})